// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/locales/fr/index.ts"
);
import.meta.hot.lastModified = "1771782356220.9434";
}
// REMIX HMR END

import labels from './labels.json';
import explore from './explore.json';
import metas from './metas.json';
import kantonsrat from './kantonsrat.json';
import news from './news.json';

export default { labels, explore, metas, kantonsrat, news }